import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  marginBottom: 4,

  '&:last-child': {
    marginBottom: 0,
  },
};

const priorityButton: SxProps<Theme> = {
  '&.Mui-disabled': {
    opacity: 1,
    color: '#37474f',
  },
};

const priorityItemContainer = {
  display: 'flex',
  marginBottom: 1,
  width: '100%',
};

const priorityListItemContainer = {
  borderRadius: '4px',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: 'rgba(168, 191, 242, 0.1)',
};

const priorityIconButton = {
  width: '10%',
};

const priorityCommentButton = {
  width: '10%',
  // Remove this when will implement the comments for the priorities
  display: 'none',
};

const styles = {
  container,
  priorityButton,
  priorityItemContainer,
  priorityListItemContainer,
  priorityIconButton,
  priorityCommentButton,
};

export default styles;
